module.exports = __webpack_public_path__ + "static/media/lavozdelsur.a373d41c.png";